'use strict';

var debounce = require('lodash/debounce');

$(() => {
    $('.js-view-more').on('click', (e) => {
        const $button = $(e.currentTarget);
        const $component = $button.closest('.seo-text-block');
        const $parent = $button.parent();
        const $seoTextContent = $component.find('.seo-text-block__text-content');
        $seoTextContent.removeClass('truncate-text');
        $seoTextContent.html($seoTextContent.data('seo-text'));
        $parent.addClass('d-none');
        $parent.next().removeClass('d-none');
    });

    /**
     * Limit the number of characters to display
     */
    function limitText() {
        const $seoTextContent = $('.seo-text-block__text-content');

        $seoTextContent.each(function () {
            const $this = $(this);

            if ($this.hasClass('truncate-text')) {
                const $viewMoreCTA = $this.closest('.seo-text-block__content-wrapper').find('.seo-text-block__view-more-cta');
                const mobileLimit = $this.data('mobile-limit');
                const tabletLimit = $this.data('tablet-limit');
                const desktopLimit = $this.data('desktop-limit');
                let textValue = $this.data('seo-text');
                let charLimit = mobileLimit;
                textValue = textValue && textValue.trim();
                // Create a jQuery object from the HTML string
                var $tempDiv = $('<div>').html(textValue);
                // Get the text content, stripping HTML tags
                var strippedText = $tempDiv.text();

                if (app.checkBreakPoint('lg') && desktopLimit) {
                    charLimit = desktopLimit;
                } else if (app.checkBreakPoint('md') && tabletLimit) {
                    charLimit = tabletLimit;
                }

                if (textValue.length > charLimit) {
                    textValue = strippedText.substring(0, charLimit) + '...';
                } else {
                    $viewMoreCTA.addClass('d-none');
                }
                $this.html(textValue);
            }
        });
    }

    $('.js-view-less').on('click', (e) => {
        const $button = $(e.currentTarget);
        const $component = $button.closest('.seo-text-block');
        const $parent = $button.parent();
        const $seoTextContent = $component.find('.seo-text-block__text-content');
        $seoTextContent.addClass('truncate-text');
        limitText();
        $parent.addClass('d-none');
        $parent.next().removeClass('d-none');
        $parent.prev('.seo-text-block__view-more-cta').removeClass('d-none');
    });

    $(document).ready(function () {
        limitText();
    });

    $(window).on(
        'orientationchange resize',
        debounce(function () {
            limitText();
        }, 300)
    );
});
